import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { QuillViewComponent } from 'ngx-quill';

@Component({
  selector: 'lib-formly-html-viewer',
  templateUrl: './html-viewer.component.html',
  styleUrl: './html-viewer.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [QuillViewComponent]
})
export class HtmlViewerComponent {
  content = input<string>();
  theme = input<string>('snow');
  sanitize = input<boolean>(false);
}
